import axios from 'axios'

// 自动领取是一次性操作；不要在这里重放成功结果或自动重试。
const userConfig = { timeout: 10000 }
export const getCurrentRelease = () => axios.get('/api/releases/current', userConfig)
export const getRelease = id => axios.get(`/api/releases/${id}`, userConfig)
export const claimRelease = id => axios.post(`/api/releases/${id}/claim`, {}, userConfig)
export const markReleaseShown = id => axios.post(`/api/releases/${id}/shown`, {}, userConfig)
export const markReleaseDismissed = id => axios.post(`/api/releases/${id}/dismissed`, {}, userConfig)
export const acknowledgeRelease = id => axios.post(`/api/releases/${id}/acknowledged`, {}, userConfig)

export const listAdminReleases = () => axios.get('/api/admin/releases')
export const getAdminRelease = id => axios.get(`/api/admin/releases/${id}`)
export const createRelease = data => axios.post('/api/admin/releases', data)
export const updateRelease = (id, data) => axios.put(`/api/admin/releases/${id}`, data)
export const importRelease = data => axios.post('/api/admin/releases/import', data)
export const publishRelease = (id, data) => axios.post(`/api/admin/releases/${id}/publish`, data)
export const offlineRelease = (id, data) => axios.post(`/api/admin/releases/${id}/offline`, data)
export const setReleasePopup = (id, data) => axios.post(`/api/admin/releases/${id}/popup`, data)
